import { Link } from 'react-router-dom';

import { Icon, Text } from '../../common/components';
import { t } from '../../common/i18n';
import { CATEGORY_ICONS, offerIcon } from '../config/catalogConfig';
import { partnerDetailPath } from '../hooks/usePreviewToken';
import { ServicePartner } from '../types';
import MemberBenefit from './MemberBenefit';

const namespace = 'OtherServices';

interface MemberDivisionCardProps {
  partner: ServicePartner;
  preview?: string | null;
}

/**
 * Jedna světlá dlaždice na celou šířku pro divizi eVlastníci u vlastníků (Finance / Reality):
 * hlavička (ikona, název, claim), přehled všech služeb divize v mřížce (ikona, titulek, výhoda,
 * jedna věta) a vpravo dole velký tlumený „watermark" symbol oblasti. Divize má jeden detail,
 * proto jedna dlaždice místo šesti samostatných karet (rozhodnutí Ondřeje 10/2026).
 * Celá dlaždice je odkaz do detailu.
 */
export const MemberDivisionCard: React.FC<MemberDivisionCardProps> = ({ partner, preview = null }) => {
  const category = partner.offers[0]?.category ?? 'other';

  return (
    <Link to={partnerDetailPath(partner.slug, preview)} className="MemberDivisionCard">
      <Icon name={CATEGORY_ICONS[category]} className="MemberDivisionCard__watermark" />

      <div className="MemberDivisionCard__head">
        <div className="MemberDivisionCard__icon">
          <Icon name={CATEGORY_ICONS[category]} />
        </div>
        <div className="MemberDivisionCard__title">
          <Text as="h2" size="h2" color="Neutral800">
            {partner.name}
          </Text>
          <Text as="p" size="body-medium" color="Neutral700">
            {partner.claim}
          </Text>
        </div>
      </div>

      <MemberBenefit partnerSlug={partner.slug} />

      {/* Dlaždice mají stejnou stavbu i výšku: ikona + titulek + perex na 2 řádky; štítek („Revize zdarma")
          sedí v pravém horním rohu dlaždice, aby neodsouval text a neřádkoval se jinak než u sousedů. */}
      <ul className="MemberDivisionCard__services">
        {partner.offers.map((offer) => (
          <li key={offer.slug} className="MemberDivisionCard__service">
            {offer.highlight && <span className="OfferHighlight MemberDivisionCard__serviceBadge">{offer.highlight}</span>}
            <Icon name={offerIcon(offer)} color="Primary600" className="MemberDivisionCard__serviceIcon" />
            <div className="MemberDivisionCard__serviceBody">
              <Text as="span" size="body-medium" weight="600" color="Neutral800" className="MemberDivisionCard__serviceTitle">
                {offer.title}
              </Text>
              <Text as="p" size="body-small" weight="500" color="Neutral700" className="MemberDivisionCard__servicePerex">
                {offer.perex}
              </Text>
            </div>
          </li>
        ))}
      </ul>

      <div className="MemberDivisionCard__footer">
        <span className="MemberDivisionCard__cta">
          {t('Card.more', namespace)}
          <Icon name="arrowRightSmall" />
        </span>
      </div>
    </Link>
  );
};

export default MemberDivisionCard;
